import { createContext, useContext, ReactNode, useState } from 'react';

export type Environment = 'dev' | 'stage' | 'prod';

interface EnvContextValue {
  env: Environment;
  setEnv: (env: Environment) => void;
}

const EnvContext = createContext<EnvContextValue>({
  env: 'dev',
  setEnv: () => {},
});

export function EnvProvider({ children }: { children: ReactNode }) {
  const [env, setEnv] = useState<Environment>(() => {
    const stored = localStorage.getItem('env') as Environment | null;
    return stored === 'prod' ? 'prod' : stored === 'stage' ? 'stage' : 'dev';
  });

  const handleSetEnv = (newEnv: Environment) => {
    setEnv(newEnv);
    localStorage.setItem('env', newEnv);
  };

  return (
    <EnvContext.Provider value={{ env, setEnv: handleSetEnv }}>
      {children}
    </EnvContext.Provider>
  );
}

export function useEnv() {
  return useContext(EnvContext);
}
